/* eslint-disable no-nested-ternary */
import React, { ReactElement } from 'react'
import styled from 'styled-components'
import { get, Alert } from '@ally/metronome-ui'
import { CustomizeApiAlertProps } from '../../types'
import { customErrorAnalytics } from '../../../analytics'

const StyledAlert = styled(Alert)`
  div {
    padding: 0;
    div {
      margin-left: ${get.space('xs')};
    }
  }
`

export const CustomizeApiAlert: React.FC<CustomizeApiAlertProps> = ({
  shouldRender,
  type,
  isDashboardError,
}): ReactElement | null => {
  const alertType = isDashboardError || type === 'error' ? 'error' : 'success'
  const header = isDashboardError
    ? "Customization isn't available right now. Try again later."
    : type === 'error'
    ? 'Customization options couldn’t be saved. Try again later.'
    : 'Customization options have been saved.'
  if (shouldRender) {
    if (type === 'error') {
      customErrorAnalytics(header)
    }
    return (
      <StyledAlert
        disableContainer
        variant={alertType}
        heading={header}
        focusOnMount
      />
    )
  }

  return null
}
